
import type { ISODate } from '@cvo/domain';

/** Availability count for a single date, mirroring the API's availabilityByDate shape */
export interface DateAvailability {
  /** ISO date (YYYY-MM-DD) this entry refers to */
  date: ISODate;
  /** Number of available trips on this date. A count of 0 disables the date */
  count: number;
}

export interface DateCarouselProps {
  /** Array of Date objects to display. If not provided, will generate dates starting from today */
  dates?: Date[];
  /** Number of days to generate when dates prop is not provided */
  defaultDaysCount?: number;
  /** Dates that should be explicitly disabled, independent of availability */
  disabledDates?: Date[];
  /** Minimum selectable date (booking window start) */
  minDate?: Date;
  /** Maximum selectable date (booking window end) */
  maxDate?: Date;
  /** Disable the carousel */
  disabled?: boolean;
  /** Per-date availability counts. Dates present with a count of 0 are disabled */
  availabilities?: DateAvailability[];
}

export type DateId = ISODate;

export type NavigationDirection = 'previous' | 'next';

/**
 * Number of date chips visible at once per breakpoint.
 * The buffer added before/after the booking window is derived from this:
 * `Math.floor(count / 2)` dates on each side, keeping the window centered
 * on the selected date even at the edges of the range.
 */
export const VISIBLE_COUNT_BY_BREAKPOINT = {
  mobile: 3,
  tablet: 5,
  desktop: 7,
} as const;

/** Buffer is added on both sides (before and after the booking window). */
export const BUFFER_SIDES = 2;